export default "__VITE_ASSET__662e1763__"